import {
  TimeEntryCategory,
  TimeManagementFilters,
  TimeManagementSortDirection,
  TimeManagementSortField,
} from "@myapp/contract";
import { toOptionalString } from "../../../../shared/lib/optionalParsers";

export interface TimeManagementFiltersForm {
  technicianName: string;
  category: TimeEntryCategory | null;
  dateFrom: string;
  dateTo: string;
  sortField: TimeManagementSortField;
  sortDirection: TimeManagementSortDirection;
}

export const INITIAL_TIME_MANAGEMENT_FILTERS: TimeManagementFiltersForm = {
  technicianName: "",
  category: null,
  dateFrom: "",
  dateTo: "",
  sortField: "startTime",
  sortDirection: "DESC",
};

export const mapFiltersFormToApi = (
  filters: TimeManagementFiltersForm,
  limit: number,
): TimeManagementFilters => ({
  limit,
  technicianName: toOptionalString(filters.technicianName),
  category: filters.category ?? undefined,
  dateFrom: toOptionalString(filters.dateFrom),
  dateTo: toOptionalString(filters.dateTo),
  sortField: filters.sortField,
  sortDirection: filters.sortDirection,
});
